import DiscountCodeList from './DiscountCodeList'
import DiscountCodeCreate from './DiscountCodeCreate';
import DiscountIcon from '@material-ui/icons/LocalOffer';

export default {
    list: DiscountCodeList,
    create: DiscountCodeCreate,
    icon: DiscountIcon,
};
